import { render, staticRenderFns } from "./BlogListSidebarPage.vue?vue&type=template&id=55ad8853&"
import script from "./BlogListSidebarPage.vue?vue&type=script&lang=js&"
export * from "./BlogListSidebarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports